var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Distributor in Korea",
      "tabActive": "Dupont Vespel®",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', {
    staticClass: "mb-lg-42"
  }, [_c('h2', {
    staticClass: "page-tit mb-18 mb-lg-24"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "386",
      "src": "/images/logos/vespel.png",
      "alt": "Dupont Vespel"
    }
  })], 1), _c('h3', {
    staticClass: "tit text-center primary--text"
  }, [_vm._v("Dupont Vespel® Distributor")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-top-img.png",
      "className": "h-lg-240px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-100"
  }, [_vm._v(" Highly demanding applications like aerospace components, semiconductor processing, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" under the most severe conditions since 1965. ")]), _c('p', {
    staticClass: "page-text color-grey-51"
  }, [_vm._v(" Highly demanding applications like aerospace components, semiconductor processing, "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" automotive manufacturing, and energy production rely on Vespel® parts to keep their equipment running. ")])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Advantages"
    }
  }, [_c('v-row', [_c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon1.png",
      "iconWidth": "50",
      "num": "01"
    }
  }, [_vm._v(" All manufactured parts are shaped according to customer needs. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon2.png",
      "iconWidth": "38",
      "num": "02"
    }
  }, [_vm._v(" It overcomes wear or friction problems, can withstand high temperatures, and can withstand the harshest operating environments. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon3.png",
      "iconWidth": "50",
      "num": "03"
    }
  }, [_vm._v(" It can keep production running smoothly and extend the use interval of consumable materials. ")]), _c('icon-line-box', {
    attrs: {
      "icon": "/images/sub/distributor/dupont/dupont-icon4.png",
      "iconWidth": "50",
      "num": "04"
    }
  }, [_vm._v(" In addition to being simple and practical, you can create lightweight parts that outperform standard metals, ceramics and other engineering plastics. ")])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    staticClass: "mb-40 mb-lg-60",
    attrs: {
      "tit": "Vespel®"
    }
  }, [_c('p', {
    staticClass: "page-text color-grey-51 mb-2 mb-lg-6"
  }, [_vm._v(" Vespel® polyimide materials provide continuous operation at cryogenic to high temperatures low wear and low friction at high PV in lubricated or unlubricated environments outstanding creep, strength, and impact resistance exceptional dimensional stability low thermal expansion and easy machinability. "), _c('br'), _vm._v(" Vespel® makes lighter weight parts not only practical, but, in many cases, better than standard metal, ceramics, and other engineering polymers such as PEEK (polyether ether ketone) and PAI (polyamide-imide). "), _c('br'), _vm._v(" Vespel® parts and shapes, both custom and stock, have been tested and proven effective in highly demanding applications around the globe. ")]), _c('p', {
    staticClass: "page-text color-grey-51 mb-30 mb-lg-52"
  }, [_vm._v(" They are available in "), _c('strong', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("sheet, rod, tube, plaque, bar, disk, ring, ball, and custom machined parts.")])]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('table', {
    staticClass: "client-table client-table-xl w-100 border-md-end"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Grade")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-1")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-1 parts and shapes are specified for their excellent physical properties, including electrical and thermal insulation at high temperatures. SP-1 is an unfilled polymer ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-3")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-3 parts and shapes are specified for seals and bearings in vacuum or dry environments. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-21")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-21 parts and shapes provide low wear and friction for bearing, thrust washers, and dynamic seals. SP-21 is a graphite-filled polymer. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-211")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-211 parts and shapes have a low coefficient of friction over a wide range of operating conditions. It exhibits low wear rates up to 300 °C (572 °F). SP-211 is a filled polymer. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-2515")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" Parts made from DuPont™ Vespel® SP-2515 offer a low coefficient of thermal expansion (CTE), excellent wear against both aluminum and steel alloys, and a low coefficient of friction in both dry and lubricated conditions. ")])])])])])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('table', {
    staticClass: "client-table client-table--last client-table-xl w-100"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "75%"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Grade")])]), _c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("Properties")])])])]), _c('tbody', [_c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-202")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-202 contactor pads, rollers, guides, and lift pin components have high reliability and long life in high temperature service. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SP-221")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SP-22 parts and shapes provide low wear and friction for bearings, thrust washers, and dynamic seals. SP-22 is a filled polymer with a coefficient of thermal expansion similar to aluminum. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-5000")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SCP-5000 is an unfilled polyimide polymer that offers high modulus and surface hardness and improved dimensional stability. Compared to traditional polyimides, it offers better strength and stiffness at high temperatures. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-50094")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SCP has higher thermal oxidative resistance than SP polyimides with superior chemical resistance. SCP-5009 and SCP-50094 approximates the CTE of aluminum. Available as stock shapes. ")])])])]), _c('tr', [_c('th', [_c('div', {
    staticClass: "table-inner"
  }, [_vm._v("SCP-5050")])]), _c('td', [_c('div', {
    staticClass: "table-inner left"
  }, [_c('div', {
    staticClass: "px-xl-16"
  }, [_vm._v(" DuPont™ Vespel® SCP has higher thermal oxidative resistance than SP polyimides with superior chemical resistance. SCP-5050 matches the CTE of steel. Available as custom parts or stock shapes. ")])])])])])])])], 1)], 1), _c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "D.H YOO",
      "tel": "+82-31-765-2268",
      "mail": "davidyoo@ist-co.kr",
      "fax": "+82-31-765-2389",
      "link": "https://www.dupont.com/vespel.html",
      "linkBg": "/images/sub/distributor/dupont/dupont-img2.png"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }